import React, { useEffect } from 'react'

const Page = () => {
  useEffect(() => {
    location.replace('/')
  }, [])

  return (
    <>
      <h1>Page Not Found</h1>
      <p>redirecting...</p>
    </>
  )
}

export default Page
